import React, {useState, useEffect} from 'react';
import {useAuth} from "./../contextos/AuthContext"
import Api from '../servicios/api'
import FondoIncio from '../imagenes/logoMuseoUTM.png';
import Alerta from '../elementos/Alerta'

const Principal = () => {
    const {sesionOff, nombresUsuario} = useAuth();
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?contadorSolicitudesPendientes")
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            if(datosRespuesta.success === 1){
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'error',
                    mensaje: datosRespuesta.filas
                });
            }
        })
        .catch(console.log)
    }, []);

    return (
        <>
            <div className='contenedor-img'>
                    <img className='img-fluid' width="700px" height="700px" src={FondoIncio} alt="" />
            </div>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setEstadoAlerta={setEstadoAlerta}
            />
        </>
    );
}

export default Principal;